export class ReconciliationCashDto {
  posDeviceId?: number;
  sweetFaceTerminalId?: number;
  merchantId: number;
  merchantName: string;
  merchantMainCurrencyId: number;
  giftCardSales: number;
  gratuities: number;
  depositsCollected: number;
  depositsToRedeem: number;
  pettyCash: number;
  cardCashUpTotal: number;
  cashCashUpTotal: number;
  currencyId: number;
  currencySymbol: string;
  currencyCode: string;
}
